
export {} from '@clayui/loading-indicator';
import __x__ from '@clayui/loading-indicator';export default __x__;